import * as actionTypes from './actionTypes';

export const mapPerformanceNextStep = () => {
  return {
    type : actionTypes.MAP_PERFORMANCE_NEXT_STEP,
    val : null
  }
}

export const mapPerformanceGoBack = () => {
  return {
    type : actionTypes.MAP_PERFORMANCE_PREVIOUS_STEP,
    val : null
  }
}

export const mapPerformanceUploadFileSuccess = (columns, data, file) => {
  return {
    type : actionTypes.MAP_PERFORMANCE_UPLOAD_FILE_SUCCESS,
    val : {
      columns : columns,
      data : data,
      file: file
    }
  }
}

export const mapPerformanceMatchColumnSuccess = (val) => {
  return {
    type : actionTypes.MAP_PERFORMANCE_MATCH_COLUMN_SUCCESS,
    val : val
  }
}

export const saveAllPerformanceMapping = (val) => {
  return {
    type : actionTypes.MAP_PERFORMANCE_SAVE_PERFORMANCE_MAPPING,
    val : val
  }
}

export const resetPerformance = () => {
  return {
    type : actionTypes.MAP_PERFORMANCE_RESET,
    val : null
  }
}

export const resetMapPerformanceStep = () => {
  return {
    type : actionTypes.MAP_PERFORMANCE_RESET_STEP,
    val : null
  }
}
